import React, { useEffect } from 'react';
import { CurrencyFormat } from '../../../../utils';
import moment from 'moment';

import useConfiguratorData from '../../../hooks/useConfiguratorData';
import useAccessoriesData from '../../../hooks/useAccessoriesData';

const ModalAccessoryDetailBody = ({ accessory, onCloseModal }) => {

    const { getSummary } = useConfiguratorData();
    const { setSelectedAccessory, checkAddedAccessory } = useAccessoriesData();

    const summary = getSummary();

    useEffect(() => {
        return () => {
            setSelectedAccessory(null);
        }
    }, [])

    return (
        <>
            {accessory &&
                <div className="modal-box">
                    <div className="close-button icon close" id="close-modal" onClick={onCloseModal}></div>
                    <div className="modal-header">
                        <div className="modal-title">
                            <div className="left-title">
                                <h1>{accessory.name}</h1>
                                <p>Información Detallada</p>
                            </div>
                            <div className="right-title">
                                {summary.accessories > 0 ? (
                                    <>
                                        <h1>Total {CurrencyFormat(summary.accessories)}</h1>
                                        <small>Monto de los accesorios seleccionados</small>
                                    </>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className="modal-body">
                        <div className="modal-left">
                            {accessory.description &&
                                <div className="description">
                                    <b>Descripción</b>
                                    <p dangerouslySetInnerHTML={{ __html: accessory.description }}></p>
                                </div>
                            }
                            <div className="specs">
                                {accessory.price && <div className="spec-item">Precio <strong>{CurrencyFormat(accessory.price)}</strong></div>}
                                {accessory.application && <div className="spec-item">Aplicación <strong>{accessory.application}</strong></div>}
                                {accessory.model_year && <div className="spec-item">Año de modelo <strong>{accessory.model_year}</strong></div>}
                                {accessory.part_number && <div className="spec-item">Nro de parte <strong>{accessory.part_number}</strong></div>}
                                {accessory.manual_ref_number && <div className="spec-item">Nro de Ref. Manual <strong>{accessory.manual_ref_number}</strong></div>}
                                {accessory.installation_time && <div className="spec-item">Tiempo de instalación <strong>{accessory.installation_time}</strong></div>}
                                {accessory.weight && <div className="spec-item">Peso <strong>{accessory.weight}</strong></div>}
                            </div>
                        </div>
                        <div className="modal-right">
                            {accessory.image && <img className="accessory-image" src={accessory.image.url} alt={accessory.image.alt} />}
                            <div className="options">
                                <button className={"btn " + (accessory.is_added ? "outline-red" : "black")} onClick={() => checkAddedAccessory(accessory)}>{accessory.is_added ? "- Quitar" : "Añadir"}</button>
                                {accessory.installation_manual &&
                                    <a href={accessory.installation_manual} target="_blank" className="download-manual">
                                        <img src={`${window._env_.STATIC_HOST}/static/website/images/icons/download-manual.svg`} />
                                        <p>Descargar manual de instalación</p>
                                    </a>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="legals-list-container">
                            {accessory.legals.length ?
                                accessory.legals.map(legal => <p key={legal.id} className="text-legal">(*) {legal.description}</p>)
                                :
                                <p className="text-legal">
                                    {accessory.price_validity ?
                                        `(*) Oferta válida hasta el ${moment(accessory.price_validity).format('DD/MM/YYYY')} en los concesionario oficiales Toyota de la República de Chile. Ninguno de los valores incluye mano de obra.`
                                        :
                                        "(*) Precios sugeridos incluyen IVA y aplican sólo para compras en Concesionarios de la Red Oficial Toyota de la República de Chile. No incluyen mano de obra ni insumos por instalación."}
                                </p>
                            }
                        </div>
                        <div className="btn-container">
                            <button className="btn black" onClick={() => setSelectedAccessory(null)}>Volver</button>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default ModalAccessoryDetailBody;